import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=2c6ba64c&scoped=true&"
import script from "./MediaDetail.vue?vue&type=script&lang=js&"
export * from "./MediaDetail.vue?vue&type=script&lang=js&"
import style0 from "./MediaDetail.vue?vue&type=style&index=0&id=2c6ba64c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ba64c",
  null
  
)

export default component.exports